import Swal from 'sweetalert2';

/**
 * Show a simple alert
 * @param {string} title - Alert title
 * @param {string} text - Alert message
 * @param {"success" | "error" | "warning" | "info" | "question"} icon - Alert icon type
 */
export const showAlert = (
  title: string,
  text: string,
  icon: 'success' | 'error' | 'warning' | 'info' | 'question',
): void => {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
};

/**
 * Show a confirmation dialog
 * @param {string} title - Confirmation title
 * @param {string} text - Confirmation message
 * @returns {Promise<boolean>} - Returns `true` if confirmed, `false` if canceled
 */
export const showConfirm = async (title: string, text: string): Promise<boolean> => {
  const result = await Swal.fire({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
  return result.isConfirmed;
};

/**
 * Show a toast notification
 * @param {string} message - Toast message
 * @param {"success" | "error" | "warning" | "info"} icon - Toast type
 */
export const showToast = (
  message: string,
  icon: 'success' | 'error' | 'warning' | 'info' = 'success'
): void => {
  Swal.fire({
    toast: true,
    position: 'top-end',
    icon,
    title: message,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });
};

/**
 * Show a timer alert
 * @param {string} title - Alert title
 * @param {string} text - Alert message
 * @param {"success" | "error" | "warning" | "info" | "question"} icon - Alert icon type
 * @param {number} timer - Duration in milliseconds before auto-close (default: 3000ms)
 */
export const showTimerAlert = (
  title: string,
  text: string,
  icon: 'success' | 'error' | 'warning' | 'info' | 'question',
  timer: number = 3000
): void => {
  Swal.fire({
    title,
    text,
    icon,
    timer,
    timerProgressBar: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  });
};
